.page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  position: relative;
}

.grainientBg {
  position: fixed;
  inset: 0;
  z-index: -1;
  overflow: hidden;
}

.card {
  background: var(--kh-surface);
  border-radius: var(--kh-radius-card);
  box-shadow: var(--kh-shadow-modal);
  padding: var(--kh-space-8) 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--kh-space-6);
  min-width: 340px;
}

.wordmark {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--kh-font);
  font-size: 22px;
  font-weight: var(--kh-font-wordmark);
  letter-spacing: var(--kh-ls-wordmark);
  text-transform: uppercase;
  color: var(--kh-text-primary);
}

.wordmarkCrown {
  font-size: 20px;
  color: var(--kh-red);
}

.divider {
  width: 100%;
  height: 1px;
  background: var(--kh-border);
}

.tagline {
  font-size: var(--kh-size-body);
  color: var(--kh-text-secondary);
  margin: 0;
  text-align: center;
}

.error {
  color: var(--kh-red);
  font-size: var(--kh-size-body);
  margin: 0;
  text-align: center;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 24px;
  background: var(--kh-red);
  color: #fff;
  border-radius: var(--kh-radius-sm);
  text-decoration: none;
  font-size: var(--kh-size-body);
  font-weight: var(--kh-font-label);
  transition: background 200ms cubic-bezier(0.34, 1.56, 0.64, 1),
              transform 300ms cubic-bezier(0.34, 1.56, 0.64, 1),
              box-shadow 300ms cubic-bezier(0.34, 1.56, 0.64, 1);
  white-space: nowrap;
}

.btn:hover {
  background: var(--kh-red);
  transform: scale(1.04);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.btn:active {
  transform: scale(1.01);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition-duration: 80ms;
}

.btnIcon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
